import { AppConfig } from '@/lib/config';

/**
 * Backend often returns `http://` absolute media URLs while the dashboard is served over `https://`,
 * which browsers block (mixed content). Relative `/media/...` paths need the API origin.
 */
export function resolveMediaUrl(url: string | null | undefined): string | undefined {
  const raw = (url ?? '').trim();
  if (!raw) return undefined;
  if (raw.startsWith('blob:') || raw.startsWith('data:')) return raw;

  let absolute = raw;

  if (raw.startsWith('//')) {
    const proto = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    absolute = `${proto}${raw}`;
  } else if (raw.startsWith('/')) {
    const base = AppConfig.apiBaseUrl.replace(/\/$/, '');
    if (base) {
      try {
        absolute = new URL(raw, base.endsWith('/') ? base : `${base}/`).href;
      } catch {
        absolute = raw;
      }
    }
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && absolute.startsWith('http://')) {
    return `https://${absolute.slice('http://'.length)}`;
  }

  return absolute;
}
